import React from "react";
import AjudaModal from "./AjudaModal";

function AjudaMestres({ pestanya, onTancar }) {
  const contingut = CONTINGUT[pestanya] || CONTINGUT.usuaris;
  return (
    <AjudaModal
      id="mestres-ajuda-title"
      titol={contingut.titol}
      lead={contingut.lead}
      onTancar={onTancar}
    >
      {contingut.cos}
    </AjudaModal>
  );
}

const CONTINGUT = {
  tipusmaobra: {
    titol: "Com funcionen els Tipus de mà d'obra",
    lead: "El tipus descriu la mena de feina (oficial, peó, tècnic…). Els grups agrupen tipus per tarifar a les tasques.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista i fitxa</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li><strong>Nou tipus</strong>: nom i, si cal, notes. Després el pots posar dins d'un grup.</li>
          </ul>
        </section>
      </>
    ),
  },
  grupsmaobra: {
    titol: "Com funcionen els Grups de mà d'obra",
    lead: "El grup és el que tries a la tasca o a la partida: un preu/hora i els tipus de mà d'obra que hi entren.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista i fitxa</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li>A la fitxa poses el nom, la tarifa i quins tipus de mà d'obra formen el grup.</li>
          </ul>
        </section>
      </>
    ),
  },
  tipusabsencia: {
    titol: "Com funcionen els Tipus d'absència",
    lead: "El catàleg de motius: vacances, assumptes propis, visita mèdica… El que tries quan crees una absència a Gestió laboral.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista i fitxa</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li>Nom, color (es veu al calendari) i si descompte hores o no. No esborra si ja s'ha fet servir.</li>
          </ul>
        </section>
      </>
    ),
  },
  tipuspausa: {
    titol: "Com funcionen els Tipus de pausa",
    lead: "Motius de pausa al Control Horari (esmorzar, dinar, personal…). El que l'empleat tria quan fitxa una pausa.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista i fitxa</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li>Nom i si la pausa compta com a temps de treball o no.</li>
          </ul>
        </section>
      </>
    ),
  },
  usuaris: {
    titol: "Com funcionen els Usuaris",
    lead: "Qui pot entrar a l'ERP, amb quin rol i a quina empresa. No és la fitxa d'empleat: un usuari pot ser o no la mateixa persona.",
    cos: (
      <>
        <section className="dv2-help-section">
          <h4>Llista</h4>
          <ul>
            <li>Doble clic per consultar. El <strong>…</strong> obre Consultar, Modificar o Esborrar.</li>
            <li><strong>Nou usuari</strong>: login, contrasenya, rol i empresa. Només pots assignar rols del teu nivell o inferior.</li>
          </ul>
        </section>
        <section className="dv2-help-section">
          <h4>Fitxa</h4>
          <p>
            Actiu / inactiu, rol (1 a 4) i si és superusuari (veu totes les empreses). No esborra un usuari de nivell
            superior al teu. La Gestió laboral i l'Agenda depenen d'aquest rol.
          </p>
        </section>
      </>
    ),
  },
};

export default AjudaMestres;
